import {styled} from "@mui/material";
export const WavesMonitorContainer = styled('div')(({ height, LTR }) => ({
  width: '100%',
  height,
  marginBottom: '20px',
  transform: LTR ? 'rotate(0deg)' : 'rotate(180deg)',
}));
